import { render, staticRenderFns } from "./IconCartOutline.vue?vue&type=template&id=3c3c5608&scoped=true&"
import script from "./IconCartOutline.vue?vue&type=script&lang=ts&"
export * from "./IconCartOutline.vue?vue&type=script&lang=ts&"
import style0 from "./IconCartOutline.vue?vue&type=style&index=0&id=3c3c5608&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3c5608",
  null
  
)

export default component.exports